import React, { useState } from "react";

import FileView, { imagetype } from "./FileFullView";
import { DocIcon, ImageIcon, PdfIcon, TxtIcon, XlsxIcon } from "../assets/icons";
export default function FileDisplay({ data,view, width = "20px", height = "20px" }) {
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);
  let ImgPath = data?.split(".").reverse()[0];
  let ImgName = data?.split("/").reverse()[0];
  
  return (
    <>
      <div className="text-center w-24 ml-6" onClick={() => {
            setShowFile(!showFile)
          }}>
        <div
          className="w-20 h-20 bg-tableodd flex justify-center items-center rounded-lg group relative cursor-pointer"
        >
          {imagetype.includes(ImgPath) ? (
            <ImageIcon height={height} width={width}/>
          ) : ImgPath == "docx" ? (
            <DocIcon height={height} width={width} />
          ): ImgPath == "docx" ? (
            <DocIcon height={height} width={width} />
          ): ImgPath == "xlsx" ? (
            <XlsxIcon height={height} width={width} />
          ) : ImgPath == "txt" ? (
            <TxtIcon height={height} width={width} />
          ) : ImgPath == "pdf" ? (
            <PdfIcon height={height} width={width} />
          ) : null}
        </div>
        <p className="w-24 text-justify text-[10px] line-clamp-3 break-words overflow-hidden">
          {ImgName}
        </p>
        <title>{ImgName}</title>
      </div>

      {view && <FileView path={data} 
      onClose={handleClose}
      visible={showFile}/>}
    </>
  )
}